import { FaArrowRight } from 'react-icons/fa'
import { AiFillHeart } from 'react-icons/ai'
import { Link } from 'react-router-dom'
import { useState } from 'react'
import Swal from 'sweetalert2'

const CoursesCard = ({
  imgUrl,
  courseName,
  courseDetail,
  courseId,
  edit = false,
  likes,
}) => {
  const [isLiked, setIsLiked] = useState(false)
  const [likesCount, setLikesCount] = useState(likes)

  const handleLikesToggle = () => {
    setIsLiked(!isLiked)
    if (isLiked) {
      fetch(`${process.env.REACT_APP_API}/course/like/${courseId}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${sessionStorage.getItem('token')}`,
        },
        body: JSON.stringify({
          likes: likesCount - 1,
        }),
      }).then((res) => {
        setLikesCount(likesCount - 1)
        Swal.fire({
          title: 'Success',
          text: 'Course unliked',
          icon: 'success',
          confirmButtonColor: '#3085d6',
        })
      })
    } else {
      fetch(`${process.env.REACT_APP_API}/course/like/${courseId}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${sessionStorage.getItem('token')}`,
        },
        body: JSON.stringify({
          likes: likesCount + 1,
        }),
      }).then((res) => {
        setLikesCount(likesCount + 1)
        Swal.fire({
          title: 'Success',
          text: 'Course liked',
          icon: 'success',
          confirmButtonColor: '#3085d6',
        })
      })
    }
  }

  return (
    <figure className="max-w-sm shadow-md h-full rounded-md flex flex-col justify-between font-nunito">
      <img
        src={imgUrl}
        className="h-36 w- object-cover rounded-md"
        alt={courseName}
      />

      <div className="p-5">
        <h5 className="mb-2 text-2xl font-bold tracking-tight text-gray-900">
          {courseName}
        </h5>
        <p className="mb-3 font-normal text-gray-700 dark:text-gray-400">
          {courseDetail}
        </p>
        <div className="flex justify-between">
          {edit ? null : (
            <Link
              to={`/course/${courseId}`}
              className="inline-flex items-center py-2 px-3 text-sm font-medium text-center text-black border-4 border-gray-600 transition-all duration-200 ease-in-out"
            >
              {'Read more'}

              <FaArrowRight />
            </Link>
          )}
          <span className="flex justify-center items-center ">
            <AiFillHeart
              className="text-2xl mx-2 text-red-600 cursor-pointer"
              onClick={handleLikesToggle}
            />
            {likesCount}
          </span>
        </div>
      </div>
    </figure>
  )
}

export default CoursesCard
